"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdvancedBillingModule = /** @class */ (function () {
    function AdvancedBillingModule() {
    }
    return AdvancedBillingModule;
}());
exports.AdvancedBillingModule = AdvancedBillingModule;
